import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Box, NavigationLeftIcon, RawButton, Text } from '@common-fe/common-fe';

import InvestmentDonut from './InvestmentDonut';

interface Props {
  children: React.ReactNode;
  switchNode: React.ReactNode;
}
const InvestmentDonutMobileModal: React.FC<Props> = ({ children, switchNode }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const handleToggle = () => {
    setVisible(!visible);
  };
  const handleClose = () => {
    setVisible(false);
  };
  return (
    <>
      <Box onClick={handleToggle} style={{ display: 'flex', flex: '1 1 0%' }}>
        {children}
      </Box>
      {visible &&
        ReactDOM.createPortal(
          <Box
            style={{ top: 0, right: 0, left: 0, bottom: 0, position: 'fixed', zIndex: 999 }}
            background="canvas"
            // overflow="auto"
            direction="column"
            pad={{ top: 'spacing24' }}
          >
            <div>
              <RawButton onClick={handleClose}>
                <Box align="center" pad={{ horizontal: 'spacing8' }} direction="row">
                  <Box justify="center" width="48px" height="48px" align="center">
                    <NavigationLeftIcon color="navigationAccent" size="18px" />
                  </Box>
                  <Text color="textAccent">{t('Asset Allocation')}</Text>
                </Box>
              </RawButton>
            </div>
            <Box
              background="module"
              round={{ corner: 'top', size: 'container3Round' }}
              style={{ position: 'relative' }}
              overflow="auto"
            >
              <Box style={{ position: 'absolute', right: 16, top: 16 }}>{switchNode}</Box>
              <InvestmentDonut isModalMode />
            </Box>
          </Box>,
          document.body
        )}
    </>
  );
};

export default InvestmentDonutMobileModal;
